export const generateKeyFromName = (name: string): string => {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z\s]/g, '') // remove non-letter characters except space
    .replace(/\s+/g, '_'); // replace spaces with underscore
};

export const validateKey = (key: string): boolean => {
  if (!key) {
    return false;
  }
  const isValid = /^[a-z]+(_[a-z]+)*$/.test(key);
  if (!isValid) {
    return false;
  }
  return true;
};
